module.exports = function getResource(label, vars = []) {
    let resources = {
        loves: 'Loves',
        signInButton: 'Sign In',
        createAccountButton: 'Create Account',
        recentlyLoved: 'Recently Loved',
        viewAll: 'View all',
        shopNow: 'Shop Now',
        itemShip: 'This item cannot be shipped to',
        noLovesDesc: 'Use your Loves list to keep track of your favorite products.'
    };
    return resources[label];
};
